import { ReactElement } from 'react';
import { Button } from '@mui/material';

import { SCHEDULE_DEMO_URL } from '~constants/commons';

import { AccessFeatureUpgradePlanButtonProps } from '../types';

const AccessFeatureUpgradePlanButtonContactSales = ({
  variant = 'contained',
  size = 'small',
  color,
  className,
}: AccessFeatureUpgradePlanButtonProps): ReactElement => (
  <Button
    variant={variant}
    size={size}
    color={color}
    className={className}
    component="a"
    href={SCHEDULE_DEMO_URL}
    target="_blank"
    rel="noopener noreferrer"
  >
    Contactar al equipo de ventas
  </Button>
);

export default AccessFeatureUpgradePlanButtonContactSales;
